// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import * as reactDeviceDetect from "react-device-detect";
import { UserAgentDeviceType } from "../enums/userAgentDeviceType";
import { METRIC_NAME } from "../logging";
import { TEST_USER_AGENT_SUFFIX } from "../constants";

let reactDevice = reactDeviceDetect.getSelectorsByUserAgent(
  window.navigator.userAgent
);

//Extract device type from user-agent and based on model names categorize them into mobile,tablet.
export function getDeviceType(): UserAgentDeviceType {
  if (reactDevice?.isTablet) {
    return UserAgentDeviceType.TABLET;
  } else if (reactDevice?.isMobile) {
    return UserAgentDeviceType.MOBILE;
  } else if (reactDevice?.isWearable) {
    return UserAgentDeviceType.WEARABLE;
  } else if (reactDevice?.isSmartTV) {
    return UserAgentDeviceType.SMARTTV;
  } else {
    return UserAgentDeviceType.DESKTOP;
  }
}

export function getDeviceTypeMetricName(
  deviceType: UserAgentDeviceType
): METRIC_NAME {
  switch (deviceType) {
    case UserAgentDeviceType.MOBILE:
      return METRIC_NAME.FROM_PHONE;
    case UserAgentDeviceType.TABLET:
      return METRIC_NAME.FROM_TABLET;
    case UserAgentDeviceType.DESKTOP:
      return METRIC_NAME.FROM_DESKTOP;
    default:
      return METRIC_NAME.FROM_DESKTOP;
  }
}

export function getDeviceBrowser(): string {
  return reactDevice?.browserName;
}

export function getDeviceModel(): string {
  const deviceModel = reactDevice?.mobileModel;
  return deviceModel === (undefined || "none") ? "Unknown" : deviceModel;
}

export function getDeviceOSName(): string {
  return reactDevice?.osName;
}

export function getDeviceTouchInfo(): string {
  return window?.navigator?.maxTouchPoints > 1
    ? "Touchscreen"
    : "Non-touchscreen";
}

export function isDeviceOnExperimentalMode(): boolean {
  const deviceType = getDeviceType();
  return isMobileDevice(deviceType) || isTabletDevice(deviceType);
}

export function isInternalTestTraffic(): boolean {
  return (
    window.navigator.userAgent != null &&
    window.navigator.userAgent.endsWith(TEST_USER_AGENT_SUFFIX)
  );
}

function isMobileDevice(deviceType: UserAgentDeviceType): boolean {
  return deviceType === UserAgentDeviceType.MOBILE;
}

function isTabletDevice(deviceType: UserAgentDeviceType): boolean {
  return deviceType === UserAgentDeviceType.TABLET;
}

//function used from tests to reset the device load.
export function updateReactDeviceForTests(): void {
  reactDevice = reactDeviceDetect.getSelectorsByUserAgent(
    window.navigator.userAgent
  );
}
